import { Col, Input, Row, Select } from "antd";
import { ChangeEvent } from "react";
import { Credential } from "../../../types/credentials";

export interface EditCredentialProps {
  credential: Credential;
  setCredential: (credential: Credential) => void;
  roles: string[];
}

const EditCredential = (props: EditCredentialProps) => {
  const { credential, setCredential, roles } = props;

  const handleOnChangePassword = (value: string) => {
    setCredential({ ...credential, password: value });
  };

  const handleOnChangeRoles = (selectedRoles: string[]) => {
    setCredential({ ...credential, roles: selectedRoles });
  };

  const options = roles.map((role) => ({
    label: role,
    value: role,
  }));

  return (
    <div>
      <Row style={{ marginTop: "5px" }}>
        <Col span={12}>Password</Col>
        <Col span={12}>
          <Input.Password
            value={credential.password}
            onChange={(e: ChangeEvent<HTMLInputElement>) =>
              handleOnChangePassword(e.target.value)
            }
          />
        </Col>
      </Row>
      <Row style={{ marginTop: "5px" }}>
        <Col span={12}>Roles</Col>
        <Col span={12}>
          <Select
            mode="multiple"
            options={options}
            value={credential.roles}
            onChange={handleOnChangeRoles}
            style={{ width: "100%" }}
          />
        </Col>
      </Row>
    </div>
  );
};

export default EditCredential;
